/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Events_MatchInputs */

const th_no_events_match = /** @type {(inputs: No_Events_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่มีรายการที่ตรงกับตัวกรอง`)
};

const en_no_events_match = /** @type {(inputs: No_Events_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No events match your filters.`)
};

const ja_no_events_match = /** @type {(inputs: No_Events_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`条件に合う大会はありません。`)
};

const zh_no_events_match = /** @type {(inputs: No_Events_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`没有赛事符合你的筛选条件。`)
};

const es_no_events_match = /** @type {(inputs: No_Events_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ningún evento coincide con tus filtros.`)
};

const pt_no_events_match = /** @type {(inputs: No_Events_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum evento corresponde aos seus filtros.`)
};

const id_no_events_match = /** @type {(inputs: No_Events_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada acara yang cocok dengan saringan Anda.`)
};

const fr_no_events_match = /** @type {(inputs: No_Events_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun événement ne correspond à vos filtres.`)
};

const tl_no_events_match = /** @type {(inputs: No_Events_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang event na tumugma sa mga salaan mo.`)
};

const vi_no_events_match = /** @type {(inputs: No_Events_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không sự kiện nào khớp bộ lọc của bạn.`)
};

const ko_no_events_match = /** @type {(inputs: No_Events_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`필터에 맞는 이벤트가 없습니다.`)
};

const de_no_events_match = /** @type {(inputs: No_Events_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Event passt zu deinen Filtern.`)
};

const ru_no_events_match = /** @type {(inputs: No_Events_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ни одно событие не подходит под ваши фильтры.`)
};

const tr_no_events_match = /** @type {(inputs: No_Events_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Süzgeçlerinize uyan etkinlik yok.`)
};

const it_no_events_match = /** @type {(inputs: No_Events_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun evento corrisponde ai tuoi filtri.`)
};

const pl_no_events_match = /** @type {(inputs: No_Events_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Żadne wydarzenie nie pasuje do twoich filtrów.`)
};

const uk_no_events_match = /** @type {(inputs: No_Events_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Жодна подія не відповідає вашим фільтрам.`)
};

const hi_no_events_match = /** @type {(inputs: No_Events_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपके फ़िल्टर से कोई आयोजन मेल नहीं खाता।`)
};

const ar_no_events_match = /** @type {(inputs: No_Events_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا توجد فعالية تطابق تصفيتك.`)
};

const ms_no_events_match = /** @type {(inputs: No_Events_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada acara sepadan dengan tapisan anda.`)
};

const bn_no_events_match = /** @type {(inputs: No_Events_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আপনার ছাঁকনির সঙ্গে কোনও আয়োজন মেলেনি।`)
};

const zh_tw2_no_events_match = /** @type {(inputs: No_Events_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`沒有賽事符合你的篩選條件。`)
};

const zh_hk2_no_events_match = /** @type {(inputs: No_Events_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`沒有賽事符合你的篩選條件。`)
};

const ur_no_events_match = /** @type {(inputs: No_Events_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آپ کے فلٹر سے کوئی ایونٹ نہیں ملا۔`)
};

const fa_no_events_match = /** @type {(inputs: No_Events_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هیچ رویدادی با پالایه‌های شما هم‌خوان نیست.`)
};

const sw_no_events_match = /** @type {(inputs: No_Events_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakuna tukio linalolingana na vichujio vyako.`)
};

const nl_no_events_match = /** @type {(inputs: No_Events_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen enkel evenement voldoet aan je filters.`)
};

/**
* | output |
* | --- |
* | "No events match your filters." |
*
* @param {No_Events_MatchInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const no_events_match = /** @type {((inputs?: No_Events_MatchInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Events_MatchInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_no_events_match(inputs)
	if (locale === "ja") return ja_no_events_match(inputs)
	if (locale === "zh") return zh_no_events_match(inputs)
	if (locale === "es") return es_no_events_match(inputs)
	if (locale === "pt") return pt_no_events_match(inputs)
	if (locale === "id") return id_no_events_match(inputs)
	if (locale === "fr") return fr_no_events_match(inputs)
	if (locale === "tl") return tl_no_events_match(inputs)
	if (locale === "vi") return vi_no_events_match(inputs)
	if (locale === "ko") return ko_no_events_match(inputs)
	if (locale === "de") return de_no_events_match(inputs)
	if (locale === "ru") return ru_no_events_match(inputs)
	if (locale === "tr") return tr_no_events_match(inputs)
	if (locale === "it") return it_no_events_match(inputs)
	if (locale === "pl") return pl_no_events_match(inputs)
	if (locale === "uk") return uk_no_events_match(inputs)
	if (locale === "hi") return hi_no_events_match(inputs)
	if (locale === "ar") return ar_no_events_match(inputs)
	if (locale === "ms") return ms_no_events_match(inputs)
	if (locale === "bn") return bn_no_events_match(inputs)
	if (locale === "zh-TW") return zh_tw2_no_events_match(inputs)
	if (locale === "zh-HK") return zh_hk2_no_events_match(inputs)
	if (locale === "ur") return ur_no_events_match(inputs)
	if (locale === "fa") return fa_no_events_match(inputs)
	if (locale === "sw") return sw_no_events_match(inputs)
	if (locale === "nl") return nl_no_events_match(inputs)
	return en_no_events_match(inputs)
});